// extracted by mini-css-extract-plugin
module.exports = {"sideMenuItem":"_3qZlxW","withArrow":"If4hDq","brandColor":"_2KQJ7U","banner":"_2Z_ocp","icon":"_3QXbI4"};